import { GraphQLQueryClass } from "@bsm/component";
import { TTimeOff, TTimeOffsResponse } from "@bsm/graphql";
export class MissingListQuery
    implements GraphQLQueryClass<TTimeOffsResponse, TResponse>
{
    public queryKey: string = "App.bo.appointment";
    public gql: string = `
        query MissingListQuery($data: JSONObject, $pageSize: Float, $page: Float, $sort: [TFilterSort!], $key: String) {
           timeoffs (
                filter: { 
                    data: $data, 
                    page: $page, 
                    pageSize: $pageSize,
                    sort: $sort,
                    key: $key
                }
            ) {
                total
                data {
                    id
                    createdAt
                    dateBegin
                    dateEnd
                    countWorkingDays
                    type {
                        designation
                    }
                    status
                    approvals {
                        approver {
                            id
                            fullName
                        }
                        isApproved
                        isRefused
                    }
                    employee {
                        id
                        fullName
                    }
                    userCreator {
                        id
                        employee {
                            fullName
                        }
                    }
                }
            }
        }
    `;
    variables?: any;
    constructor(variables?: any) {
        const mergedData = {
            ...(variables?.data || {}),
            type: {
                designation: 'ABSENCE'
            }
        };

        if (variables?.data?.employee && variables?.data?.employee?.department?.id === -1) {
            mergedData.employee.department = undefined
        }
        
        this.variables = {
            ...variables,
            data: mergedData
        };
    }
    mapFn(data: TResponse): TTimeOffsResponse {
        return {
            total: data.timeoffs.total,
            data: data.timeoffs.data,
        };
    }
}

export type TResponse = {
    timeoffs:{
        total:number,
        data:Array<TTimeOff>
    }
}